import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import Layout from '@/container/Layout';
import { HotlineClientContactCompleteView } from '@/feature/hotline/client/detail/contact/complete/page/HotlineClientContactCompleteView';
import { useHotlineClientContactFormContext } from '@/feature/hotline/client/detail/contact/context/HotlineClientContactFormContext';
import { useHotlineClientDetailDataContext } from '@/feature/hotline/client/detail/context/HotlineClientDetailDataContext';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン今後の進め方 完了（ロジック部分のみ）
 */
export const HotlineClientContactCompletePage = () => {
    const { id = '', requestId = '' } = useParams();
    const { setFormValues } = useHotlineClientContactFormContext();
    // データ取得処理（入力画面で行っているためここで fetch しない）
    const { detailData } = useHotlineClientDetailDataContext();
    const detailOneData = detailData[id];
    useEffect(() => {
        // フォームの状態をリセット
        setFormValues(null);
    }, [setFormValues]);
    // 詳細データが取得できなかった場合
    if (!detailOneData) {
        return _jsx(CustomRedirect, { to: pagePath.mypage.client.hotline() });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.client.contactComplete(id, requestId), title: `${detailOneData.title} 今後の進め方を相談 - 完了 | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineClientContactCompleteView, { id: id, title: detailOneData.title }) }))] }));
};
